<!-- twilio-settings.component.html -->
<div class="container">
  <br/>
  <h5><i class="fas fa-phone"></i> Twilio Settings</h5>

  
    <form [formGroup]="twilioForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="accountSid">Account SID</label>
        <input id="accountSid" formControlName="accountSid" class="form-control" />
      </div>
  
      <div class="form-group">
        <label for="authToken">Auth Token</label>
        <input id="authToken" formControlName="authToken" class="form-control" />
      </div>
  
      <div class="form-group">
        <label for="phoneNumber">Phone Number</label>
        <input id="phoneNumber" formControlName="phoneNumber" class="form-control" />
      </div>
  
      <button type="submit" class="btn btn-outline-primary" [disabled]="!twilioForm.valid">
        Update
      </button>
    </form>
  
    <!-- Success Message -->
    <div *ngIf="successMessage" class="alert alert-success mt-2">
      {{ successMessage }}
    </div>
  
    <!-- Error Message -->
   <!--  <div *ngIf="errorMessage" class="alert alert-danger mt-2">
      {{ errorMessage }}
    </div> -->
  </div>
  
